var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLifetimeWarranty = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 4268 1024",
  id: "icon-lifetime-warranty"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#5d87a1",
  stroke: "#fff",
  strokeWidth: 29.4383,
  strokeMiterlimit: 10,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  d: "M3542.765 512c0 273.281-609.229 494.819-1360.752 494.819s-1360.752-221.538-1360.752-494.819c0-273.281 609.229-494.819 1360.752-494.819s1360.752 221.538 1360.752 494.819z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#e58e1a",
  stroke: "#fff",
  strokeWidth: 29.4383,
  strokeMiterlimit: 10,
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  d: "M4254.067 728.483c0 79.034-17.181 106.523-96.215 106.523 0 0-769.718-58.416-2020.51-58.416s-2027.383 58.416-2027.383 58.416c-79.034 0-96.215-27.49-96.215-106.523v-436.403c0-79.034 17.181-106.523 96.215-106.523 0 0 591.034 58.416 2027.383 58.416 1436.349 3.436 2020.51-58.416 2020.51-58.416 79.034 0 96.215 27.49 96.215 106.523v436.403z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M237.101 608.215h127.141v44.671h-178.685v-271.463h51.544v226.792z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M439.839 652.886h-51.544v-271.463h51.544v271.463z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M536.054 498.255h120.268v41.235h-120.268v113.396h-51.544v-271.463h178.685v44.671h-127.141v72.161z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M745.664 494.819h127.141v41.235h-127.141v72.161h134.013v44.671h-185.557v-271.463h185.557v44.671h-134.013v68.725z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1030.872 652.886h-51.544v-226.792h-79.034v-44.671h209.611v44.671h-79.034v226.792z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1185.503 652.886h-51.544v-271.463h51.544v271.463z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1415.732 652.886h-48.107l-85.906-226.792 3.436 226.792h-51.544v-271.463h82.47l72.161 202.738 72.161-202.738h85.906v271.463h-51.544l3.436-226.792h-3.436l-79.034 226.792z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M1645.96 494.819h127.141v41.235h-127.141v72.161h134.013v44.671h-185.557v-271.463h185.557v44.671h-134.013v68.725z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2274.792 381.423h51.544l-72.161 271.463h-75.597l-54.98-206.174-54.98 206.174h-75.597l-68.725-271.463h51.544l54.98 226.792 61.852-226.792h58.416l61.852 226.792 61.852-226.792z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2388.188 601.342l-13.745 51.544h-54.98l89.342-271.463h75.597l92.779 271.463h-51.544l-17.181-51.544h-120.268zM2450.040 422.658v0l-48.107 140.886h92.779l-44.671-140.886z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2649.342 563.544v89.342h-51.544v-271.463h137.45c58.416 0 82.47 20.617 82.47 82.47 0 41.235-3.436 68.725-48.107 75.597v0c37.799 3.436 44.671 24.054 44.671 61.852v51.544h-51.544v-51.544c0-24.054-10.309-37.799-34.362-37.799h-79.034zM2718.067 518.872c37.799 0 48.107-6.872 48.107-48.107 0-37.799-6.872-44.671-44.671-44.671h-72.161v92.779h68.725z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2910.497 563.544v89.342h-51.544v-271.463h137.45c58.416 0 82.47 20.617 82.47 82.47 0 41.235-3.436 68.725-48.107 75.597v0c37.799 3.436 44.671 24.054 44.671 61.852v51.544h-51.544v-51.544c0-24.054-10.309-37.799-34.362-37.799h-79.034zM2979.221 518.872c37.799 0 48.107-6.872 48.107-48.107 0-37.799-6.872-44.671-44.671-44.671h-72.161v92.779h68.725z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3168.215 601.342l-17.181 51.544h-54.98l89.342-271.463h79.034l92.779 271.463h-51.544l-17.181-51.544h-120.268zM3226.631 422.658v0l-48.107 140.886h92.779l-44.671-140.886z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3577.128 381.423h51.544v271.463h-85.906l-116.832-226.792h-3.436l3.436 226.792h-51.544v-271.463h85.906l116.832 226.792v-226.792z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M3783.302 652.886h-51.544v-226.792h-79.034v-44.671h209.611v44.671h-79.034v226.792z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4010.094 549.799v103.087h-51.544v-103.087l-96.215-168.376h58.416l65.289 116.832 65.289-116.832h58.416l-99.651 168.376z"
})));
export default SvgLifetimeWarranty;